module.exports = __webpack_public_path__ + "img/1502950202.ddc53c60.jpg";